import React, { Component } from "react";

// address: null
// confirm_password: "Sagar12!@"
// contactno: "9847252863"
// enabled: true
// fullname: "Sagar Poudel"
// id: 1
// password: "Sagar12!@"
// roleId: 1
// username: "sagar12"

// address: null
// confirm_password: "Sagar12!@"
// contactno: null
// enabled: true
// fullname: "test"
// id: null
// password: "Sagar12!@"
// roleId: 1
// username: "test12"

import AddUser from "./AddUser";
import ViewUser from "./ViewUser";
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from "../../../constants";

const axios = require("axios");

export default class UserRegistration extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.OnEditClick = this.OnEditClick.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.setUserGroup = this.setUserGroup.bind(this);
    this.childRef = React.createRef();
    this.state = {
      user: {
        id: 1,
        fullname: "",
        contactno: "",
        username: null,
        password: null,
        confirm_password: null,
        roleId: null,
        enabled: true,
      },
      rules: {
        fullname: ["required"],
        username: ["required", "length[5,50]"],
        password: {
          required: true,
          passwordCriteria: {
            validator(value) {
              //console.log(value);
              const regx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
              return regx.test(value);
            },
            message:
              "Password field must have atleast 1 Speical , 1 Small , 1 capital , 1 Numeric Character and Minimum 8 charcter length",
          },
        },
        confirm_password: {
          required: true,
          passwordCriteria: {
            validator(value) {
              const regx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
              return regx.test(value);
            },
            message:
              "Confirm Password field must have atleast 1 Speical , 1 Small , 1 capital , 1 Numeric Character and Minimum 8 charcter length",
          },
        },
        user_group: ["required"],
      },
      operation: "Add",
      selected: {},
      permissions: [],
    };
  }

  async setUserGroup() {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    if (access_token != null) {
      axios
        .get(API_URL + "api/allroles", axiosConfig)
        .then((response) => {
          if (response.status === 200 && response.data.length > 0) {
            this.setState({
              allGroups: response.data,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.setUserGroup();
      }
    }
  }

  componentDidMount() {
    var data = getCookie("permission");

    this.setState(
      {
        permissions: JSON.parse(data),
      },
      function () {
        setTitle("User Registration");
        this.setUserGroup();
      }
    );
  }

  OnEditClick() {
    if (this.state.selected != null) {
      var rules = this.state.rules;
      delete rules.password;
      delete rules.confirm_password;
      this.setState(
        {
          rules: rules,
          user: this.state.selected,
          operation: "Update",
        },
        function () {
          this.childRef.current.validate((errors) => {});
        }
      );
    }
  }

  onSelectionChange(selectedRow) {
    this.setState({
      selected: selectedRow,
    });
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    this.setState({ user: user });
  }
  render() {
    var permissions = this.state.permissions;

    return (
      <div className='container-fluid'>
        <div className='row'>
          {permissions.includes("user-registration-create") ? (
            <div className='col-5 '>
              <AddUser
                userFields={this.state.user}
                validationRules={this.state.rules}
                handleChange={this.handleChange}
                operation={this.state.operation}
                ref={this.childRef}
                allGroups={this.state.allGroups}
              />
            </div>
          ) : (
            ""
          )}
          {permissions.includes("user-registration-view") ? (
            <div className='col-7 '>
              <ViewUser
                selectedRow={this.state.selected}
                OnEditClick={this.OnEditClick}
                onSelectionChange={this.onSelectionChange}
                permissions={permissions}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
